var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#002E6E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29399_18067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.111 7.778C10.2102 7.77811 10.3055 7.81606 10.3776 7.8841C10.4497 7.95215 10.493 8.04514 10.4988 8.14409C10.5046 8.24304 10.4725 8.34048 10.4088 8.41649C10.3452 8.4925 10.255 8.54134 10.1565 8.55305L10.111 8.55577H4.8276L5.71932 9.44749C5.78907 9.51748 5.82956 9.61139 5.83258 9.71014C5.8356 9.8089 5.80091 9.90511 5.73556 9.97921C5.67021 10.0533 5.57911 10.0998 5.48075 10.1091C5.38239 10.1185 5.28415 10.0901 5.20599 10.0297L5.16944 9.99738L3.67999 8.50794C3.42138 8.24972 3.58705 7.81455 3.93782 7.78033L3.98255 7.778H10.111ZM8.28055 4.00305C8.34751 3.93609 8.4366 3.89587 8.53111 3.88993C8.62562 3.88398 8.71906 3.91273 8.79388 3.97077L8.83044 4.00305L10.3199 5.4925C10.5785 5.75072 10.4128 6.18588 10.062 6.22011L10.0173 6.22244H3.88882C3.7897 6.22233 3.69437 6.18438 3.62229 6.11633C3.55022 6.04829 3.50684 5.95529 3.50104 5.85634C3.49523 5.75739 3.52742 5.65996 3.59104 5.58395C3.65466 5.50794 3.7449 5.45909 3.84332 5.44738L3.88882 5.44466H9.17227L8.28055 4.55294C8.20764 4.48001 8.16668 4.38111 8.16668 4.278C8.16668 4.17488 8.20764 4.07598 8.28055 4.00305Z",
    fill: "#002E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29399_18067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(2.33337 2.3335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/Transfer-icon.ea946ac7e44dfc6ad4f0d2b35ee04b0a.svg";
export { ForwardRef as ReactComponent };